import {
  faGlobe,
  faUserShield,
  faBuildingUser,
} from "@fortawesome/free-solid-svg-icons"

const linksUrl = {
  login: "/",
  adminMaster: {
    add: "/admin-master/add",
    read: "/admin-master",
    edit: "/admin-master/edit",
  },
  clientMaster: {
    read: "/client-master",
    add: "/client-master/add",
    edit: {
      password: "/client-master/edit/p",
      details: "/client-master/edit/d",
    },
  },
  userMaster: {
    read: "/user-master",
    add: "/user-master/add",
    edit: "/user-master/edit",
  },
  appMaster: {
    read: "/app-master",
    add: "/app-master/add",
    edit: "/app-master/edit",
  },
  appClientMapping: {
    read: "/app-client-mapping",
    add: "/app-client-mapping/add",
    edit: "/app-client-mapping/edit",
  },
  menuMaster: {
    read: "/menu-master",
    add: "/menu-master/add",
    edit: "/menu-master/edit",
  },
  userMenuMapping: {
    read: "/user-menu-mapping",
    add: "/user-menu-mapping/add",
    edit: "/user-menu-mapping/edit",
  },
}

const apiRoute = {
  clientMaster: {
    add: "/client-master/add",
    read: "/client-master",
    edit: {
      password: "/client-master/edit/p",
      details: "/client-master/edit/d",
    },
  },
  userMaster: {
    add: "user-master/add",
    read: "/user-master",
    edit: "/user-master",
  },
  adminMaster: {
    add: "admin-master/add",
    read: "/admin-master",
    edit: "/admin-master",
    login: "/admin-master",
  },
  appMaster: {
    add: "app-master/add",
    read: "/app-master",
    edit: "/app-master",
    delete: "/app-master",
  },
  appClientMapping: {
    add: "app-client-mapping/add",
    read: "/app-client-mapping",
    edit: "/app-client-mapping",
    delete: "/app-client-mapping",
  },
  menuMaster: {
    add: "menu-master/add",
    read: "/menu-master",
    edit: "/menu-master",
    delete: "/menu-master",
  },
  userMenuMapping: {
    add: "user-menu-mapping/add",
    read: "/user-menu-mapping",
    edit: "/user-menu-mapping",
    delete: "/user-menu-mapping",
  },
}

const stateEnum = {
  clientMaster: "clientMaster",
  userMaster: "userMaster",
  adminMaster: "adminMaster",
  auth: "auth",
  appMaster: "appMaster",
  appClientMapping: "appClientMapping",
  menuMaster: "menuMaster",
  userMenuMapping: "userMenuMapping",
}

const sideNavLinks = [
  {
    name: "Client Master",
    icon: faBuildingUser,
    url: linksUrl.clientMaster.read,
  },
  {
    name: "App Master",
    icon: faGlobe,
    url: linksUrl.appMaster.read,
  },
  {
    name: "Admin Master",
    icon: faUserShield,
    url: linksUrl.adminMaster.read,
  },
] 

export { linksUrl, apiRoute, stateEnum, sideNavLinks }
